/**
 * FeaturesSection Component
 * Product features/benefits grid
 */
export function FeaturesSection() {
  const assetsUrl = `${window.template_root}/src/public/`;

  const features = [
    {
      icon: `${assetsUrl}img/science-baked.webp`,
      title: "Science-backed solutions",
      description:
        "Evidence-based formulas deliver consistent, reliable results every day.",
    },
    {
      icon: `${assetsUrl}img/transparency.webp`,
      title: "Manufacturing transparency",
      description:
        "Transparent sourcing and production keep every step trustworthy.",
    },
    {
      icon: `${assetsUrl}img/solutions.webp`,
      title: "Effective solutions",
      description:
        "Purposeful formulas meet your goals quickly with precision and impact.",
    },
    {
      icon: `${assetsUrl}img/sustainability.webp`,
      title: "True sustainability",
      description:
        "Responsible choices minimize footprint while supporting a healthier future.",
    },
  ];

  return (
    <section className="py-12 px-8 pb-[4.5rem] max-md:py-4 max-md:px-4">
      <div
        className="grid grid-cols-4 gap-8 max-w-[1200px] mx-auto text-center
                      max-md:grid-cols-1 max-md:gap-0"
      >
        {features.map((feature, index) => (
          <div
            key={index}
            className="flex flex-col items-center gap-3
                       max-md:flex-row max-md:items-start max-md:py-4 max-md:px-3 max-md:gap-4
                       max-md:border-b max-md:border-light-gray max-md:last:border-b-0"
          >
            <div className="flex justify-center items-center mb-2 max-md:flex-shrink-0 max-md:mb-0">
              <img
                src={feature.icon}
                alt=""
                className="w-12 h-12 object-contain max-md:w-9 max-md:h-9"
              />
            </div>
            <div className="text-center max-md:text-left">
              <h3 className="font-semibold text-[1.1rem] max-md:text-base max-md:leading-[1.3] max-md:mb-1">
                {feature.title}
              </h3>
              <p className="text-gray text-sm leading-relaxed mt-0.5 max-md:text-sm max-md:leading-relaxed max-md:mt-0.5">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FeaturesSection;
